export interface UploadErrorContextI {
  fileName?: string
  fileSize?: number
  fileType?: string
  allowedExtensions?: string[]
  maxFileNameLength?: number
  maxFileSizeInBytes?: number
}

export class UploadError extends Error {
  context?: UploadErrorContextI

  constructor(message: string, context?: UploadErrorContextI) {
    super(message)
    this.context = context
  }
}

export const UPLOAD_FAILED = 'Failed to upload file.'

export const FILE_INCORRECT_TYPE = 'File has incorrect type.'
export const FILE_TOO_LARGE = 'File is too large.'

export const FILENAME_INCORRECT_CHARACTERS =
  'Filename contains unsupported characters.'

export const FILENAME_TOO_LONG = (maxLength: number) =>
  `Filename should have less than ${maxLength} characters.`
export const FILE_CONTENT_MISMATCH = (extension: string) =>
  `This file's contents don't match its .${extension} extension.`

export const FILE_INCORRECT_EXTENSION = (
  allowedExtension: string,
  uploadedExtension?: string
) =>
  uploadedExtension
    ? `.${uploadedExtension} files are not supported. Please upload a .${allowedExtension} file.`
    : `File should have ${allowedExtension} extension.`
export const FILE_INCORRECT_EXTENSIONS = (
  allowedExtensions: string[],
  uploadedExtension?: string
) => {
  const supported = allowedExtensions.map((e) => `.${e}`).join(', ')
  return uploadedExtension
    ? `.${uploadedExtension} files are not supported. Supported types: ${supported}.`
    : `Incorrect file extension. Allowed extensions: ${allowedExtensions.join(
        ' '
      )}`
}
